import { connect } from 'react-redux'
import Hamburger from 'components/layout/Hamburger'
import { hideNavigation, showNavigation } from 'redux/actions'

const mapStateToProps = state => ({
  deviceType: state.layout.deviceType
})

const mapDispatchToProps = dispatch => ({
  showNavigation: () => dispatch(showNavigation()),
  hideNavigation: () => dispatch(hideNavigation())
})

export default connect(mapStateToProps, mapDispatchToProps)(Hamburger)
